var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSkipForward = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.788 17.444C7.71311 17.4968 7.62515 17.528 7.53374 17.5341C7.44233 17.5403 7.35098 17.5213 7.26966 17.4791C7.18834 17.4369 7.12018 17.3731 7.07263 17.2948C7.02507 17.2165 6.99995 17.1266 7 17.035V6.965C6.99995 6.87338 7.02507 6.78351 7.07263 6.7052C7.12018 6.62689 7.18834 6.56315 7.26966 6.52094C7.35098 6.47873 7.44233 6.45968 7.53374 6.46586C7.62515 6.47205 7.71311 6.50323 7.788 6.556L14.921 11.592C14.9862 11.6382 15.0394 11.6994 15.0761 11.7703C15.1128 11.8413 15.132 11.9201 15.132 12C15.132 12.0799 15.1128 12.1587 15.0761 12.2297C15.0394 12.3006 14.9862 12.3618 14.921 12.408L7.788 17.444ZM16 7C16 6.73478 16.1054 6.48043 16.2929 6.29289C16.4804 6.10536 16.7348 6 17 6C17.2652 6 17.5196 6.10536 17.7071 6.29289C17.8946 6.48043 18 6.73478 18 7V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18C16.7348 18 16.4804 17.8946 16.2929 17.7071C16.1054 17.5196 16 17.2652 16 17V7Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSkipForward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/skip-forward.3ae7d39a5ef8daaf6b92ea8b2dca4fe6.svg";